var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
export const credentialsAuthProvider = (apiUrl, fetchJson) => ({
    login: async (_a) => {
        var { username, password, publicKey } = _a, params = __rest(_a, ["username", "password", "publicKey"]);
        try {
            const headers = new Headers({
                'Content-Type': 'application/json; charset=UTF-8',
            });
            if (publicKey) {
                headers.set('Public-Key', publicKey);
            }
            const { json } = await fetchJson(`${apiUrl}/authenticate/login`, {
                method: 'POST',
                body: JSON.stringify(Object.assign({ username,
                    password, eula: 'accept' }, params)),
                headers: headers,
            });
            const { respCode, respMsg } = json;
            if (respCode < 200 || respCode >= 300) {
                throw new Error(respMsg);
            }
        }
        catch (error) {
            console.error(error);
            throw new Error(error);
        }
    },
    logout: async () => {
        try {
            await fetchJson(`${apiUrl}/logout`);
            return Promise.resolve();
        }
        catch (error) {
            console.error(error);
        }
    },
    checkAuth: () => {
        return Promise.resolve();
    },
    checkError: () => {
        return Promise.resolve();
    },
    getPermissions: async () => {
        return Promise.resolve();
    },
});
//# sourceMappingURL=credentialsAuthProvider.js.map